import { tokens } from 'src/design-system';
import { commonStyleSheet } from 'src/Library/CommonStyles';

const commonStyles = {
  ...commonStyleSheet,
  box: {
    ...commonStyleSheet.flexRow,
    marginBottom: tokens.spacing.ms,
    padding: 20,
    alignItems: 'normal',
    boxSizing: 'border-box',
    border: '1px solid #F7F7F7',
    borderRadius: tokens.radius.md,
    boxShadow: '2px 2px 6px 0 rgba(0,0,0,0.05)',
    backgroundColor: tokens.colors.bgWhite,
  },
  flexRow: {
    ...commonStyleSheet.flexRow,
    justifyContent: 'space-between',
  },
  input: {
    width: 250,
    '& .ant-select-selection--single': {
      width: 250,
    },
    minWidth: 250,
    maxWidth: 250,
  },
  formItem: {
    marginBottom: 10,
    width: '45%',
    ...commonStyleSheet.flexRow,
    '& .ant-form-item-label': {
      lineHeight: '14px',
      textAlign: 'left',
      width: '30%',
    },
    '& .ant-form-item': {
      marginBottom: 0,
    },
    '& .ant-form-explain': {
      fontSize: tokens.fontSize.caption,
    },
  },
  ellipses: {
    fontSize: tokens.fontSize.small,
    maxWidth: '94%',
    display: 'flex',
    wordWrap: 'break-word',
    whiteSpace: 'initial',
    margin: 0,
    padding: 0,
  },
  labelEllipsis: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  textValue: {
    padding: `0 0 ${tokens.spacing.ms}px ${tokens.spacing.sm}px`,
  },
  required: {
    color: '#EB2727',
    fontSize: tokens.fontSize.small,
  },
  boxTitle: {
    ...commonStyleSheet.flexColumn,
    fontSize: tokens.fontSize.h3,
    color: tokens.colors.textSecondary,
    fontWeight: 'bold',
    width: '15%',
  },
  boxFields: {
    width: '80%',
  },
  boxIcon: {
    width: '20%',
    fontSize: tokens.fontSize.h3,
    color: tokens.colors.textSecondary,
    textAlign: 'left',
  },
  configLoader: {
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
    background: '#f0f8ff66',
    zIndex: 1,
    // backdropFilter: 'blur(0.5px)',
    top: '53px',
  }
};

export const newShipmentStyles = {
  ...commonStyles,
  main: {
    fontFamily: 'Open Sans',
    letterSpacing: 0,
    '& .ant-drawer-header': {
      padding: tokens.spacing.ms,
    },
    '& .ant-drawer-body': {
      padding: 0,
      backgroundColor: '#F1EEE7',
    },
    marginBottom: 100,
  },
  newButton: {
    height: 28,
    borderRadius: tokens.radius.md,
    fontSize: tokens.fontSize.small,
    backgroundColor: `${tokens.colors.primaryDark} !important`,
    border: `1px solid ${tokens.colors.primaryDark}`,
  },
  header: {
    ...commonStyleSheet.flexRow,
    fontWeight: tokens.fontWeight.semibold,
    fontSize: tokens.fontSize.h1,
    color: '#000000',
  },
  booking: {
    ...commonStyleSheet.flexRow,
    backgroundColor: '#FFF',
    alignItems: 'center',
    padding: `${tokens.spacing.lg}px 20px`,
    color: tokens.colors.textSecondary,
    fontFamily: 'Open Sans',
    fontSize: tokens.fontSize.small,
    fontWeight: tokens.fontWeight.semibold,
    boxSizing: 'border-box',
    boxShadow: '2px 2px 6px 0 rgba(0,0,0,0.05)',
  },
  pageSelector: {
    ...commonStyleSheet.flexRow,
    boxSizing: 'border-box',
    border: '1px solid #FAF6EF',
    borderRadius: tokens.radius.md,
    backgroundColor: '#FCFAF4',
    boxShadow: '2px 2px 6px 0 rgba(0,0,0,0.05)',
  },
  tabSelector: {
    padding: 20,
    ...commonStyleSheet.flexRow,
    alignItems: 'center',
    width: '30%',
    cursor: 'pointer',
  },
  filledCircle: {
    height: 20,
    width: 20,
    borderRadius: 10,
    border: '2px solid #FFF',
  },
  tabName: {
    marginLeft: tokens.spacing.sm,
    color: tokens.colors.text,
    fontSize: tokens.fontSize.body,
  },
  tabDescription: {
    fontSize: tokens.fontSize.caption,
    marginLeft: tokens.spacing.sm,
  },
  tabIcon: {
    height: tokens.spacing.lg,
    width: tokens.spacing.lg,
    borderRadius: 12,
  },
  dot: {
    color: '#27B479',
    fontSize: tokens.spacing.lg,
  },
  inComplete: {
    color: '#DF1D1D',
    fontSize: tokens.spacing.lg,
  },
  footer: {
    ...commonStyleSheet.footer,
    ...commonStyleSheet.flexRow,
    height: 65,
    justifyContent: 'flex-start',
    paddingRight: '20%',
    fontSize: tokens.fontSize.body,
    backgroundColor: 'white',
    borderTop: `1px solid ${tokens.colors.border}`,
    opacity: 1,
  },
};

export const newShipmentThirdStyles = {
  ...commonStyles,
  main: {
    marginBottom: 75,
    overflowY: 'auto',
    maxHeight: 560,
    backgroundColor: '#F1EEE7',
  },
};

export const newShipmentSecondStyles = {
  ...commonStyles,
  main: {
    marginBottom: 75,
    overflowY: 'auto',
    maxHeight: 560,
    backgroundColor: '#F1EEE7',
  },
  checkboxGroup: {
    ...commonStyleSheet.flexColumn,
    marginTop: 10,
    fontSize: tokens.fontSize.body,
    fontWeight: tokens.fontWeight.semibold,
    color: '#222222',
  },
};

export const newShipmentFirstStyles = {
  ...commonStyles,
  main: {
    marginBottom: 75,
    overflowY: 'auto',
    maxHeight: 560,
    backgroundColor: '#F1EEE7',
  },
  productSelect: {
    width: 250,
    marginRight: 8,
  },
  productQuantity: {
    width: 90,
    marginRight: 8,
  },
  productUnit: {
    width: 90,
    marginRight: 8,
  },
  productCross: {
    color: 'red',
    width: 24,
    marginTop: -6,
    marginLeft: 8,
  },
  productLabel: {
    width: '13.5%',
    color: '#262626',
    fontSize: tokens.fontSize.small,
  },
  containerFields: {
    width: 120,
    '& .ant-select-selection--single': {
      width: 120,
    },
    minWidth: 64,
    maxWidth: 120,
  },
  containerFieldsSmall: {
    width: 64,
    '& .ant-select-selection--single': {
      width: 64,
    },
    minWidth: 64,
    maxWidth: 120,
  },
  containerFieldsLarge: {
    width: 200,
    '& .ant-select-selection--single': {
      width: 200,
    },
    minWidth: 200,
    maxWidth: 200,
  },
  containerWeight: {
    width: 180,
    '& .ant-select-selection--single': {
      width: 180,
    },
    minWidth: 180,
    maxWidth: 180,
  },
  formItemGauge: {
    display: 'grid',
    gridTemplateColumns: 'max-content 10% 10% 10% max-content',
    gridGap: '10px',
    '& .ant-checkbox-wrapper': {
      fontSize: tokens.fontSize.caption,
    }
  },
  locationDropdownWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '250px',
  },
  locationAddressDisplay: {
    fontSize: tokens.fontSize.small,
    color: '#666',
    marginTop: `${tokens.spacing.xs}px`,
    height: '64px',
    lineHeight: '16px',
    width: '250px',
    overflow: 'hidden',
    wordWrap: 'break-word',
  },
  locationFormItem: {
    alignItems: 'flex-start',
  }
};
